import { f7, useStore } from 'framework7-react';
import { usePaymentList } from './api/payment/usePaymentList';
import { useToast } from './useToast';
import { customerInfoApi } from '@/api/customerApi';
import { AuthInfoState, initialState } from '@/config/initialState';
import { store } from '@/config/store';
import { paymentStorage } from '@/utils/paymentStorage';
import { storeDispatch } from '@/utils/store';

export const useGmoRegisterAndEditRedirect = () => {
  const router = f7.views.main.router;
  const authInfo = useStore(store, 'authInfo') as AuthInfoState;
  const customerId = paymentStorage.getItem('m_customer_id');
  const token = paymentStorage.getItem('token');
  const { openToast } = useToast();
  const { updatePaymentList, isFetched, isFetching } = usePaymentList(false);

  const fetchAndSetCustomerInfo = async (mCustomerId: string | null) => {
    if (!mCustomerId) return;
    try {
      const { data: customerInfo } = await customerInfoApi({
        m_customer_id: Number(mCustomerId),
      });
      if (!customerInfo?.success) return;
      const {
        customer,
        cars,
        bill_infomations,
        payment_methods,
        prepaids,
        informations,
        campaigns,
      } = customerInfo;
      await Promise.all([
        storeDispatch(
          'setCarItemInfo',
          'carItemInfo',
          cars ? cars[0] : initialState.carItemInfo,
        ),
        storeDispatch('setCustomerInfo', 'customerInfo', customer),
        storeDispatch('setCarsInfo', 'carsInfo', cars),
        storeDispatch('setBillsInfo', 'billsInfo', bill_infomations),
        storeDispatch(
          'setPaymentMethodsInfo',
          'paymentMethodsInfo',
          payment_methods,
        ),
        storeDispatch(
          'setAdvancePaymentsInfo',
          'advancePaymentsInfo',
          prepaids,
        ),
        storeDispatch(
          'setNotificationsInfo',
          'notificationsInfo',
          informations,
        ),
        storeDispatch('setCampaignsInfo', 'campaignsInfo', campaigns),
        storeDispatch(
          'setWarranties',
          'warranties',
          cars?.[0]?.warranties || [],
        ),
        storeDispatch(
          'setNextWarranties',
          'nextWarranties',
          cars?.[0]?.next_warranty || [],
        ),
        storeDispatch(
          'setCurrentWarranty',
          'currentWarranty',
          cars?.[0]?.warranties?.[0],
        ),
        storeDispatch(
          'setNextWarranty',
          'nextWarranty',
          cars?.[0]?.next_warranty?.[0],
        ),
      ]);
    } catch (e) {
      console.error('GMOリダイレクト後の顧客情報取得に失敗しました', e);
    }
  };

  const handleGmoRegisterAndEditRedirect = async (
    status: string,
    isLoggedIn: boolean,
  ) => {
    if (!isLoggedIn) return;
    const mCustomerId = paymentStorage.getItem('m_customer_id');

    switch (status) {
      case 'gmo_success':
        await fetchAndSetCustomerInfo(mCustomerId);
        if (!isFetched && !isFetching) {
          updatePaymentList(Number(mCustomerId));
          openToast(
            'カードの登録・編集が完了しました。',
            'toast-success',
            3000,
            true,
            'top',
          );
          return;
        }
        break;
      case 'gmo_cancel':
        openToast(
          'カードの登録・編集がキャンセルされました。',
          'toast-failed',
          3000,
          true,
          'top',
        );
        break;
    }
  };

  return {
    handleGmoRegisterAndEditRedirect,
  };
};
